import { useEffect, useState } from "react"
import { useLocation } from "react-router-dom"
import axios from "axios"
import { apiRoot } from './ApiConfig'
import { useT } from "./i18n/LanguageContext"

const Activate = () => {
  const location = useLocation()
  const t = useT()
  const [status, setStatus] = useState("progress")

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const activationKey = params.get("activation_key")
    if (!activationKey) {
      setStatus("missingKey")
      return
    }

    //axios.post(apiRoot + "api/users/activate", { activation_key: activationKey })
    axios.post(apiRoot + "activate", { activation_key: activationKey })
      .then(res => {
        console.log("activate RES",res)
        if (res.data.success) {
          setStatus("done")
        } else {
          setStatus("badKey")
        }
      })
      .catch(() => setStatus("error"))
  }, [location.search])

  const texts = {
    progress: t("userui.activate.progress", "Activating account..."),
    missingKey: t("userui.activate.missingKey", "Missing activation_key!"),
    done: t("userui.activate.done", "Your VoxDoc account is registered, you can close this browser tab or browser window"),
    badKey: t("userui.activate.badKey", "Incorrect activation_key!"),
    error: t("userui.activate.error", "An error occurred during activation"),
  }

  return <div className="p-4 text-center">{texts[status]}</div>
}

export default Activate